import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { ToastService } from './toast.service';

/**
 * La región viva existe desde que arranca el shell, vacía: un lector de pantalla sólo anuncia los
 * cambios en una región que ya conocía. Por eso no se usa `ion-toast`, que crea su nodo al presentar.
 */
@Component({
  selector: 'ui-toast-host',
  template: `
    <div class="region" role="status" aria-live="polite" aria-atomic="true">
      @if (toast.message(); as message) {
        <div class="toast">{{ message }}</div>
      }
    </div>
  `,
  styleUrl: './toast-host.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastHostComponent {
  protected readonly toast = inject(ToastService);
}
